import React from "react";
import "./popupModal.scss";

const PopupModal = ({
  isOpen, // boolean value
  onClose, // call back function
  onSave, // call back function
  customRender, // jsx custom renders
  popupHeading, // string
  enableSave = false,
  disableSave = false,
  width = "80%",
  popupType = "side", // side(side means it comes from right side) or center (top to center)
  className = "",
  minWidth,
}) => {
  const RenderPopupButtons = () => {
    return (
      <>
        {enableSave && (
          <div className="popupButtonsWrapper">
            <button
              className={`saveBtn ${disableSave ? "disabled" : ""}`}
              onClick={() => {
                onSave();
              }}
              style={{
                pointerEvents: `${disableSave ? "none" : ""}`,
                opacity: `${disableSave ? 0.5 : 1}`,
              }}
              disabled={disableSave}
            >
              SAVE
            </button>
            <div
              className="cancelBtn"
              onClick={() => {
                onClose();
              }}
            >
              CANCEL
            </div>
          </div>
        )}
      </>
    );
  };

  const RenderRightSidePopup = () => {
    if (popupType !== "side") return null;
    return (
      <>
        {/* since parent to access any content is popupModal so adding fragmens */}
        <div className={isOpen ? "popupOverlay" : ""}></div>
        <div
          className={`popupModal ${isOpen ? "open" : ""}`}
          style={{
            width: width,
            minWidth,
          }}
        >
          <div className="popupModalContent">
            <button
              type="button"
              className="close"
              onClick={() => {
                onClose();
              }}
            >
              ×
            </button>
            <div className="popupContent">
              <div className="popupContentBodyWrapper">
                <div className="modalHeading"> {popupHeading} </div>
                <div className={`ModalBodyContent ${className || ""}`}>
                  {customRender()}
                </div>
              </div>
              {RenderPopupButtons()}
            </div>
          </div>
        </div>
      </>
    );
  };

  const RenderCenterPopup = () => {
    if (popupType !== "center") return null;

    return (
      <>
        <div className={isOpen && "centerPopupOverlay"}></div>
        <div
          className={`centerPopupModal ${isOpen ? "open" : ""}`}
          style={{
            width: width,
          }}
        >
          <div className="popupModalContent">
            <button
              type="button"
              className="close"
              onClick={() => {
                onClose();
              }}
            >
              x
            </button>
            <div className="popupContent">
              <div className="popupContentBodyWrapper">
                <div className="modalHeading"> {popupHeading} </div>
                <div className="ModalBodyContent">{customRender()}</div>
              </div>
              {RenderPopupButtons()}
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      {RenderRightSidePopup()}
      {RenderCenterPopup()}
    </>
  );
};

export default PopupModal;
